import CreativeType from '@/Enums/Creatives/CreativeType.enum';

export default class CreativeTypeService {
  /**A.k.a all asset creative types */
  public static readonly inlineCreativeTypes = [
    CreativeType.VIDEO,
    CreativeType.DISPLAY,
    CreativeType.HTML5,
    CreativeType.AUDIO,
  ];
  public static readonly wrapperCreativeTypes = [CreativeType.VIDEO_VAST, CreativeType.AUDIO_VAST];
  public static readonly sizeCreativeTypes = [CreativeType.DISPLAY_TAG, CreativeType.HTML5];
  public static readonly clickUrlCreativeTypes = [CreativeType.VIDEO, CreativeType.DISPLAY, CreativeType.AUDIO];

  public static isInline(creativeType: CreativeType): boolean {
    return this.inlineCreativeTypes.includes(creativeType);
  }

  public static isWrapper(creativeType: CreativeType): boolean {
    return this.wrapperCreativeTypes.includes(creativeType);
  }

  public static hasSize(creativeType: CreativeType): boolean {
    return this.sizeCreativeTypes.includes(creativeType);
  }

  public static hasClickUrl(creativeType: CreativeType): boolean {
    return this.clickUrlCreativeTypes.includes(creativeType);
  }
}
